import { useEffect } from 'react';
import useShowInvitationModal from './useShowInvitationModal';
import {
  getAutoShowInvitationModal,
  removeAutoShowInvitationModal,
} from './autoShowInvitationModal';

const useAutoShowInvitationModalEffect = () => {
  const showInvitationModal = useShowInvitationModal();

  useEffect(() => {
    if (getAutoShowInvitationModal()) {
      removeAutoShowInvitationModal();
      showInvitationModal();
    }
  }, [showInvitationModal]);
};

export default useAutoShowInvitationModalEffect;
